import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';
import { RootState } from 'types/store';
import { toggle as toggleAction } from '../store/modules/drawer/actions';

const mapStateToProps = (state: RootState) => ({
  open: state.drawer.open
});

const mapDispatchToProps = (dispatch: Dispatch) =>
  bindActionCreators(
    {
      toggleDrawer: toggleAction
    },
    dispatch
  );

interface IDrawerState {
  open: boolean;
}

interface IDrawerDispatch {
  toggleDrawer: (open: boolean) => void;
}

export type WithDrawerProps = IDrawerDispatch & IDrawerState;

const withDrawerState = connect(
  mapStateToProps,
  mapDispatchToProps
);

export default withDrawerState;



// WEBPACK FOOTER //
// ./src/enhancers/withDrawerState.tsx